import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import { useCallback } from "react";
import { confirmSAML, loginSAML, logout } from "Admin/Service/Auth";
const LOGIN_QUERY_KEYS = {
  LOGIN_SAML: "LOGIN_SAML",
  CONFIRM_SAML: "CONFIRM_SAML",
};
export const useLoginSAML = (enabled) => {
  const client = useQueryClient();
  const { data, error, isFetching } = useQuery({
    queryKey: [LOGIN_QUERY_KEYS.LOGIN_SAML, enabled],
    queryFn: () => loginSAML(),
    refetchOnWindowFocus: false,
    enabled: enabled,
  });
  const reloadFunction = () => {
    client.refetchQueries({ queryKey: [LOGIN_QUERY_KEYS.LOGIN_SAML] });
  };
  return {
    data,
    error,
    isLoading: isFetching,
    reloadFunction,
  };
};
export const useConfirmLogin = (payload, enabled) => {
  const client = useQueryClient();
  const { data, error, isFetching } = useQuery({
    queryKey: [LOGIN_QUERY_KEYS.CONFIRM_SAML, enabled],
    queryFn: () => confirmSAML(payload),
    refetchOnWindowFocus: false,
    enabled: enabled,
  });
  const reloadFunction = () => {
    client.refetchQueries({ queryKey: [LOGIN_QUERY_KEYS.CONFIRM_SAML] });
  };
  return {
    data,
    error,
    isLoading: isFetching,
    reloadFunction,
  };
};
